import React from "react"

export const ElektronischesVergabemanagement = ({ size = 1 }) => {
  return (
    <svg
      width={87 * size}
      height={75 * size}
      viewBox="0 0 87 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="#E5EDF0" d="M15 0h72v56H15z" />
      <path
        clipRule="evenodd"
        d="M50.852 59.753a1 1 0 01.892.548l6.36 12.543H17.896l6.2-12.534a1 1 0 01.897-.557h25.86z"
        stroke="#034055"
        strokeWidth={3}
      />
      <path
        fill="#FFD62E"
        stroke="#FFD62E"
        strokeWidth={3.5}
        d="M2 13h72v46.753H2z"
      />
      <rect x={8} y={19} width={6} height={6} rx={3} fill="#034055" />
      <rect x={19} y={19} width={6} height={6} rx={3} fill="#034055" />
      <rect x={29} y={19} width={6} height={6} rx={3} fill="#034055" />
    </svg>
  )
}
